"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentCard = /** @class */ (function () {
    function PaymentCard() {
    }
    return PaymentCard;
}());
exports.default = PaymentCard;
//# sourceMappingURL=PaymentCard.js.map